var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images)?_c('SlicedImageLayer',{attrs:{"bounds":_vm.bounds,"images":_vm.images}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }